export const removeHtmlFromString = (str) => {
  if (!str) return "";
  return str.replace(/(<([^>]+)>)/gi, "");
};
